import React from "react";

export const BackHandler = ({ title, customBackUrl }) => {
  return (
    <a role="back-handler" href={customBackUrl}>
      <img src="/img/new-icons/back-button.svg" />
      <span>{title}</span>
    </a>
  );
};
